/*
 * Planner Messages
 *
 * This contains all the text for the Planner component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.components.Planner.BlockModal.header',
    defaultMessage: 'Block {id}: {time}',
  },
  slotCount: {
    id: 'app.components.Planner.BlockModal.slotCount',
    defaultMessage: '{count} time slots',
  },
  openCount: {
    id: 'app.components.Planner.BlockModal.openCount',
    defaultMessage: '{open}/{count} time slots available',
  },
  meeting: {
    id: 'app.components.Planner.BlockModal.meeting',
    defaultMessage: 'Meeting',
  },
  break: {
    id: 'app.components.Planner.BlockModal.break',
    defaultMessage: 'Break',
  },
  makeMeeting: {
    id: 'app.components.Planner.BlockModal.makeMeeting',
    defaultMessage: 'Make Meeting',
  },
  makeBreak: {
    id: 'app.components.Planner.BlockModal.makeBreak',
    defaultMessage: 'Make Break',
  },
  removeSlot: {
    id: 'app.components.Planner.BlockModal.removeSlot',
    defaultMessage: 'Remove Time Slot',
  },
  removeBlock: {
    id: 'app.components.Planner.BlockModal.removeBlock',
    defaultMessage: 'Remove this block?',
  },
  addSlot: {
    id: 'app.components.Planner.BlockModal.addSlot',
    defaultMessage: 'Add Time Slot',
  },
  copyConfirm: {
    id: 'app.components.Planner.BlockModal.copyConfirm',
    defaultMessage: 'A copy of the time slot has been created',
  },
  assign: {
    id: 'app.components.Planner.BlockModal.assign',
    defaultMessage: 'Assign',
  },
  unassign: {
    id: 'app.components.Planner.BlockModal.unassign',
    defaultMessage: 'Unassign',
  },
  block: {
    id: 'app.components.Planner.BlockModal.block',
    defaultMessage: 'Block',
  },
  unblock: {
    id: 'app.components.Planner.BlockModal.unblock',
    defaultMessage: 'Unblock',
  },
  blocked: {
    id: 'app.components.Planner.BlockModal.blocked',
    defaultMessage: 'Blocked',
  },
  meetingGone: {
    id: 'app.components.Planner.BlockModal.meetingGone',
    defaultMessage: 'The meeting has been removed',
  },
  noCancel: {
    id: 'app.components.Planner.BlockModal.noCancel',
    defaultMessage: 'You can only cancel if no meetings are planned yet',
  },
  select: {
    id: 'app.components.Planner.BlockModal.select',
    defaultMessage: 'Select',
  },
  occupied: {
    id: 'app.components.Planner.BlockModal.occupied',
    defaultMessage: 'Occupied',
  },
  singleSlot: {
    id: 'app.components.Planner.BlockModal.singleSlot',
    defaultMessage: 'A block is intended for multiple time slots, possibly with a break in between. Click on \'Add Time Slot\' to extend the block.',
  },
  changeTime: {
    id: 'app.components.Planner.BlockModal.changeTime',
    defaultMessage: 'Change Start Time',
  },
});
